// extracted by mini-css-extract-plugin
module.exports = {"container":"Cards_container__1bLbo","card":"Cards_card__1uv4b","infected":"Cards_infected__1B6BN","recovered":"Cards_recovered__aj0i-","deaths":"Cards_deaths__1YuMB"};